import { render } from "./ApiKeyPairPermissionTable.vue?vue&type=template&id=1d92db4a&scoped=true"
import script from "./ApiKeyPairPermissionTable.vue?vue&type=script&lang=js"
export * from "./ApiKeyPairPermissionTable.vue?vue&type=script&lang=js"

import "./ApiKeyPairPermissionTable.vue?vue&type=style&index=0&id=1d92db4a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d92db4a"]])

export default __exports__